import Base from './base'

export default class MelodyRequiredFields extends Base {
  async getRequiredFields() {
    try {
      return this.api.get('required_fields.json?sl_object_type=person')
    } catch (e) {
      return null
    }
  }
}
